export default __webpack_public_path__ + "static/media/checked.a4efd94b.gif";